import React, {FC} from 'react';

interface SlideIndicatorProps {
    currentSlide: number;
    totalSlides: number;
}

export const SlideIndicator: FC<SlideIndicatorProps> = ({currentSlide, totalSlides}) => {
    return (
        <div
            className="absolute bottom-4 right-4 z-10 flex min-h-5 w-13 transform items-center justify-center
      rounded-full bg-KPZ_disable text-sm font-bold text-white">
            {currentSlide < 9 ? `0${currentSlide}` : currentSlide}/{totalSlides < 10 ? `0${totalSlides}` : totalSlides}
        </div>
    );
};
